module.exports = __webpack_public_path__ + "static/media/up-chevron.456cd003.svg";